export function extractQueryErrorMessage(error: unknown): string | undefined {
  if (!error || typeof error !== "object") return undefined;

  const err = error as {
    data?: { messages?: string[]; message?: string };
    error?: string;
  };

  const messages = err.data?.messages;
  if (Array.isArray(messages) && messages.length > 0) return messages[0];
  if (typeof err.data?.message === "string") return err.data.message;
  if (typeof err.error === "string") return err.error;

  return undefined;
}
